import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { theme } from '../utils/theme';
import { device } from '../utils/mediaQueries';

const SkillsSection = styled.section`
  padding: 80px 20px;
  background: ${theme.cardBackground};
  color: ${theme.text};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  ${device.tablet} {
    padding: 100px 40px;
  }

  ${device.laptop} {
    padding: 120px 60px;
  }
`;

const Container = styled.div`
  max-width: 900px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
`;

const SectionTitle = styled(motion.h2)`
  font-size: clamp(1.75rem, 5vw, 3rem);
  margin-bottom: 1rem;
  color: ${theme.white};
  font-weight: 700;
  letter-spacing: -0.02em;
`;

const Subtitle = styled(motion.p)`
  color: ${theme.secondary};
  font-family: ${theme.fontMono};
  font-size: 0.9rem;
  margin-bottom: 2.5rem;
  letter-spacing: 0.05em;
  
  ${device.tablet} {
    font-size: 1rem;
    margin-bottom: 3rem;
  }
`;

const SkillsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
  justify-content: center;
  max-width: 750px;
  margin: 0 auto;
  
  ${device.tablet} {
    gap: 0.75rem;
  }
`;

const SkillBadge = styled(motion.div)`
  background: ${theme.background};
  padding: 0.6rem 1.1rem;
  border-radius: 50px;
  font-family: ${theme.fontMono};
  font-size: 0.8rem;
  color: ${theme.text};
  border: 1px solid ${theme.darkGray};
  transition: ${theme.transition};
  cursor: default;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    border-color: rgba(255, 255, 255, 0.3);
    color: ${theme.white};
    transform: translateY(-2px);
  }

  ${device.tablet} {
    font-size: 0.9rem;
    padding: 0.7rem 1.4rem;
  }
`;

const Skills = () => {
  const skills = [
    'JavaScript (ES6+)',
    'TypeScript',
    'React.js',
    'Node.js',
    'Express',
    'HTML5 & CSS3',
    'Styled Components',
    'Tailwind CSS',
    'REST APIs',
    'Firebase',
    'Git & GitHub',
    'Responsive Design',
    'Framer Motion'
  ];

  return (
    <SkillsSection id="skills">
      <Container>
        <Subtitle data-aos="fade-up">
          My expertise
        </Subtitle>
        <SectionTitle data-aos="fade-up" data-aos-delay="100">
          Skills & Technologies
        </SectionTitle>

        <SkillsGrid>
          {skills.map((skill, index) => (
            <SkillBadge
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: index * 0.04 }}
              viewport={{ once: true }}
            >
              {skill}
            </SkillBadge>
          ))}
        </SkillsGrid>
      </Container>
    </SkillsSection>
  );
};

export default Skills;